module.exports = __webpack_public_path__ + "media/images/logo-e7f8465bcf10eb60756e8c2e83e83840.png";